module.exports = __webpack_public_path__ + "img/nt85-08-82-1.asm.8fc2d764.jpg";